export default {
  getSuccessNotifications(state) {
    return state.success_notifications;
  },
  getSuccessNotificationTime(state){
    return state.success_notification_time
  },
}
